import { RESPONSES_ACTION as ACTION_TYPE } from '../types/actionTypes';
import { getPropertyFromPayload } from '../lib';
const getActionTypeKey = actionType => {
  switch (actionType) {
    case ACTION_TYPE.SET_RESPONSES:
      {
        return 'responses';
      }
    case ACTION_TYPE.SET_RESPONSES_LOADING:
      {
        return 'responsesLoading';
      }
    case ACTION_TYPE.SET_RESPONSES_ERROR:
      {
        return 'responsesError';
      }
    case ACTION_TYPE.SET_RESPONSES_PAGE_SIZE:
      {
        return 'responsesPageSize';
      }
    case ACTION_TYPE.SET_RESPONSES_PAGE:
      {
        return 'responsesPage';
      }
    case ACTION_TYPE.SET_RESPONSES_COUNT:
      {
        return 'responsesCount';
      }
    case ACTION_TYPE.SET_RESPONSES_TOTAL:
      {
        return 'responsesTotal';
      }
    case ACTION_TYPE.SET_RESPONSES_CHANGED:
      {
        return 'responsesChanged';
      }
    case ACTION_TYPE.SET_SIGNIFICANT_CHANGES_TO_RESPONSES:
      {
        return 'significantChangesResponses';
      }
    case ACTION_TYPE.SET_SHOW_SA:
      {
        return 'showSA';
      }
    case ACTION_TYPE.SET_SA_STATS:
      {
        return 'saStats';
      }
    case ACTION_TYPE.SET_MULTIPLE:
      {
        return 'multiple';
      }
  }
  return '';
};
const reducer = (state, action) => {
  const {
    type,
    payload
  } = action;
  const k = getActionTypeKey(type);
  switch (k) {
    case 'multiple':
      {
        return Object.assign(Object.assign({}, state), payload);
      }
    case '':
      {
        throw new Error(`Unknown action: ${type}`);
      }
    default:
      {
        if (getPropertyFromPayload(k, payload) === undefined) {
          break;
        }
        return Object.assign(Object.assign({}, state), {
          [k]: getPropertyFromPayload(k, payload)
        });
      }
  }
  throw new Error('Error with payload provided');
};
export default reducer;